// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Navigation-module--wrapper--1_odd","menu":"Navigation-module--menu--1C-ke","header":"Navigation-module--header--3-IMV","list":"Navigation-module--list--1wqv1"};